<div class="informate_select_wrapper" [formGroup]="form">
    <mat-label class="mat-label-general" [ngbTooltip]="nutStandard_tooltip" placement="right" container="body" tooltipClass="custom-tooltip">
        <!-- Nut Standard -->
        {{ 'CUSTOM_FLANGE_PAGE.LABELS.CALC_INPUT.NUT_STANDARD' | transloco }}
    </mat-label>
    <!--tool-tip template start-->
    <ng-template #nutStandard_tooltip>
        <p>
            {{ 'TOOLTIP.INFORMATE_CALC_LABELS.NUT_STANDARD' | transloco }}
        </p>
    </ng-template>
    <!--tool-tip template end-->
    <mat-select class="mat-select-general input-form-class" formControlName="nutStandard" name="nut_standard" [class.spinner]="loading">
        <mat-option class="option-list" *ngFor="let ndl of nutDimensionList" [value]="ndl.nutDimensionId">{{ ndl.nutStandard }}</mat-option>
    </mat-select>
</div>
